import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, queryKeys, useAccessToken } from "src/http";

type Variables = {
  metricCollectionGuid: string;
  metricGuid: string;
};

const useRemoveMetricFromCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function removeMetricFromCollectionRequest(variables: Variables) {
    const accessToken = await getAccessToken();

    const response = await fetch(
      `${configuration.apiRootUrl}/metric-collections/${variables.metricCollectionGuid}/metrics/${variables.metricGuid}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "delete",
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { removeMetricFromCollectionRequest };
};

const useRemoveMetricFromCollection = () => {
  const { removeMetricFromCollectionRequest } = useRemoveMetricFromCollectionRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeMetricFromCollectionRequest,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.metrics.getMetricCollection(variables.metricCollectionGuid),
      });
    },
  });
};

export { useRemoveMetricFromCollection };
